import React from "react";
import { isMobile } from "react-device-detect";
import styled, { css } from "styled-components";
import PropTypes from "prop-types";

import UserProfile from "./UserProfile";
import ButtonsSection from "./ButtonsSection";
import AdditionalServices from "./AdditionalServices";

import breakpoints from "_constants/breakpoints";

const Row = styled.div`
  display: flex;
  justify-content: center;

  @media (max-width: 1350px) {
    flex-direction: column;
    align-items: center;
  }

  ${({ theme: { mobile } }) =>
    mobile &&
    css`
      flex-direction: column;
      padding: 32px 48px;

      @media (max-width: 600px) {
        padding: 24px;
      }

      @media (max-width: ${breakpoints.mobileM}) {
        padding: 0;
      }
    `}
`;

export default function InfoSection({ scrollToContent, handleSelectUpsell }) {
  return (
    <Row>
      {isMobile ? (
        <>
          <ButtonsSection scrollToContent={scrollToContent} />
          <UserProfile />
          <AdditionalServices handleSelectUpsell={handleSelectUpsell} />
        </>
      ) : (
        <>
          <UserProfile />
          <ButtonsSection />
          <AdditionalServices handleSelectUpsell={handleSelectUpsell} />
        </>
      )}
    </Row>
  );
}

InfoSection.propTypes = {
  scrollToContent: PropTypes.func,
  handleSelectUpsell: PropTypes.func,
};
